export default __webpack_public_path__ + "static/media/c001-E-commerce-3.adc398a1.jpg";